import { h as __h } from "preact";
import html from "~/util/html.js";
import Icon from "~/component/Icon.js";
import Tooltip from "~/component/Tooltip.js";
/** @import { TriggerProps } from "~/component/Tooltip.js"; */

import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./AgentIcon.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./AgentIcon.module.css", import.meta.url);
const css = adopt(sheet);
export default function AgentIcon() {
  return __h(Tooltip, {
    contents: "Agent"
  }, (/** @type {TriggerProps} */trigger) => __h("button", {
    ...trigger,
    "class": css.icon
  }, __h(Icon, {
    name: "robot",
    size: 16,
    label: "Agent"
  })));
}